import React, { cloneElement, FC, CSSProperties, Ref, ReactElement, ReactNode } from 'react';
import { Options } from '@popperjs/core';
import { Popup, usePopupState, bindSupportingElement } from '../Popup';
import { useUniqId } from '../../hooks/useUniqId';
const TooltipVariants = {
  default: 'default'
};
export const Tooltip = ({
  children,
  className,
  content,
  controlRef,
  hasArrow = true,
  innerRef,
  isVisible,
  offset = 3,
  placement = 'bottom',
  style
}) => {
  const popupState = usePopupState({
    triggers: ['focus', 'hover'],
    isTooltip: true
  });
  const id = useUniqId('tooltip');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/cloneElement(children, {
    ...bindSupportingElement(id, popupState)
  }), /*#__PURE__*/React.createElement(Popup, {
    className: className,
    hasArrow: hasArrow,
    id: id,
    innerRef: innerRef || controlRef,
    isVisible: isVisible || popupState.visibleId === id,
    offset: offset,
    placement: placement,
    style: style,
    target: popupState.supportingHTMLElement,
    variant: "dark"
  }, content));
};
if (process.env.NODE_ENV !== 'production') {
  Tooltip.displayName = 'Tooltip';
}